import React, { memo } from 'react';
import {
  convertToDate,
  lineHeightStyle,
  styledComponent,
} from '../../../../../utils/helpers';
import CommonDeleteBtn from '../../commonDeleteBtn';
import ChiefComplain from '../../../modals/chiefComplain';
import ChiefComplainDeleteBtn from '../../chiefComplainDeleteBtn';

const InvestigationView = ({
  selectedHistories,
  setSelectedHistories,
  prescriptionItems,
  isHistoryPage,
}) => {
  const deleteData = (fieldName, delId) => {
    const updatedInvestigations = selectedHistories?.investigations?.filter(
      (investigation) => investigation.name !== delId,
    );
    setSelectedHistories({
      ...selectedHistories,
      investigations: updatedInvestigations,
    });
  };

  const Title = styledComponent(
    prescriptionItems?.items?.['history']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['history']?.subItemStyle || {},
  );

  return (
    <>
      {selectedHistories?.investigations?.length > 0 && (
        <div className="text-left">
          <div className="">I/H</div>
          <ul style={lineHeightStyle('history', prescriptionItems)}>
            {selectedHistories?.investigations?.map((data, index) => (
              <li key={index}>
                <span className="text-left pr-5">
                  <Title>
                    {data.name}{' '}
                    {data.investigationDate
                      ? ` - ${convertToDate(data.investigationDate)}`
                      : ''}
                  </Title>

                  <Value>
                    {data?.result && (
                      <span className="pl-1">
                        -{' '}
                        <i>
                          {data.result} {data?.unit}
                        </i>
                      </span>
                    )}
                  </Value>
                </span>
                {!isHistoryPage && (
                  <ChiefComplainDeleteBtn
                    action={deleteData}
                    itemName={'investigations'}
                    delId={data.name}
                  />
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default memo(InvestigationView);
